import { useTranslation } from "react-i18next";

import { CityFilter } from "../city-filter";
import { useDiscoverCities } from "../../state/discover-context";
import { useTripActions } from "../../state/trip-context";
import { dayCity } from "../../lib/trip-route";
import type { Trip, TripDay } from "../../types";

/**
 * The city a day is in, as a small menu in the day's heading: a trip's route
 * is asked at the start, and any day can move to another city later (owner,
 * 2026-11-01). Read-only views pass `editable={false}` and get the name only.
 */
export function DayCityPicker({
  trip,
  day,
  dayIndex,
  editable = true,
}: {
  trip: Trip;
  day: TripDay;
  dayIndex: number;
  editable?: boolean;
}) {
  const { t } = useTranslation();
  const cities = useDiscoverCities();
  const { setDayCity } = useTripActions();
  const slug = dayCity(trip, day);
  const name = cities.find((c) => c.slug === slug)?.name ?? slug.charAt(0).toUpperCase() + slug.slice(1);

  if (!editable || cities.length === 0) {
    return <span className="mj-trip-day-city">{name}</span>;
  }
  return (
    <CityFilter
      cities={cities}
      selectedSlug={slug}
      onSelect={(next) => next && next !== slug && setDayCity(trip.id, day.id, next)}
      includeAll={false}
      compact
      triggerLabel={t("trip.route.day_city", { number: dayIndex + 1, city: name })}
    />
  );
}
